import type { CompressedImage } from "./image";

// Extension per wire type. Cosmetic on the server (it keys off the mimeType),
// but a PDF named ".jpg" is confusing in logs and in the multipart body.
const EXTENSION: Record<string, string> = {
  "application/pdf": "pdf",
  "image/jpeg": "jpg",
  "image/png": "png",
};

/**
 * Build the multipart body for /api/scan.
 *
 * Wraps each blob in a File carrying the mimeType that image.ts *detected*,
 * rather than trusting the blob's own `type`. Some file pickers hand over a
 * File with an empty type; the browser then labels the part
 * application/octet-stream, which Vertex rejects outright ("mimeType parameter
 * with value application/octet-stream, which is not supported") — surfacing to
 * the user as a failed scan. image.ts already falls back to the .pdf filename
 * in that case, so the detected type is the one worth sending.
 */
export function buildScanForm(images: CompressedImage[]): FormData {
  const form = new FormData();
  images.forEach((img, i) => {
    const ext = EXTENSION[img.mimeType] ?? "bin";
    form.append(
      `image_${i}`,
      new File([img.blob], `page_${i}.${ext}`, { type: img.mimeType }),
      `page_${i}.${ext}`,
    );
  });
  return form;
}
